import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import {
  PROCUREMENT_STATE_LABELS,
  PROCUREMENT_STATE_MANUAL,
  type RequestItemProcurementState,
} from '@crm/shared'
import { setProcurementState } from '../../../shared/api/requestItems.api'

interface ProcStateButtonsProps {
  role: string | undefined
  myProcState: RequestItemProcurementState
  itemId: string
}

export function ProcStateButtons({ role, myProcState, itemId }: ProcStateButtonsProps) {
  const queryClient = useQueryClient()
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (role !== 'PROCUREMENT' || myProcState === 'QUOTED') return null

  return (
    <div className="col-span-2 sm:col-span-4">
      <div className="text-xs text-gray-400 mb-1">Мой статус</div>
      <div className="flex items-center gap-1.5 flex-wrap">
        {PROCUREMENT_STATE_MANUAL.map((s) => (
          <button
            key={s}
            onClick={async () => {
              if (saving) return
              setSaving(true)
              setError(null)
              try {
                await setProcurementState(itemId, s)
                await queryClient.invalidateQueries({
                  queryKey: ['item-proc-state', itemId],
                })
              } catch (err: unknown) {
                const msg =
                  (
                    err as {
                      response?: { data?: { error?: { message?: string } } }
                    }
                  )?.response?.data?.error?.message ?? 'Не удалось сохранить'
                setError(msg)
              } finally {
                setSaving(false)
              }
            }}
            disabled={saving || myProcState === s}
            className={`px-2.5 py-1 text-xs rounded-lg border transition-colors ${
              myProcState === s
                ? 'bg-brand-600 text-white border-brand-600'
                : 'border-gray-200 text-gray-700 hover:bg-gray-50'
            } disabled:opacity-60`}
          >
            {PROCUREMENT_STATE_LABELS[s]}
          </button>
        ))}
      </div>
      {error && <div className="text-xs text-red-600 mt-1">{error}</div>}
    </div>
  )
}
